module.exports = __webpack_public_path__ + "fonts/7cb44a2.woff";